<template>
  <div style="padding:20px;">
    <div class="baseinfo">
      <div>
        <label>讲师姓名：</label>
        <span class="info">{{base_info.teacher_name}}</span>
      </div>
      <div>
        <label>学员姓名：</label>
        <span class="info">{{base_info.user_name}}</span>
      </div>
      <div>
        <label>上课时间：</label>
        <span class="info">{{base_info.course_time}}</span>
      </div>
    </div>
    <div style="margin-bottom:15px;">
      <Checkbox v-model="onlyTeacher" @on-change="onlyShowTeacher">只看老师</Checkbox>
      <Checkbox v-model="onlyStudent" @on-change="onlyShowStudent">只看学生</Checkbox>
    </div>
    <div>
      <div class="record" v-for="item in list" :key="item.date">
        <div style="margin-right:15px;">
          <div style="margin-bottom:10px;">
            <span class="record-date">{{item.day}}</span>
            <span>{{item.month+"月"}}</span>
          </div>
          <div style="margin-bottom:10px;">{{item.week}}</div>
          <div>{{item.year+"年"}}</div>
        </div>
        <div>
          <div class="record-item" v-for="record in item.items" :key="record.id">
            <div style="margin-right:10px;">{{record.communicate_at}}</div>
            <div class="ivu-timeline-item">
              <div class="ivu-timeline-item-tail"></div>
              <div class="ivu-timeline-item-head ivu-timeline-item-head-blue"></div>
              <div class="ivu-timeline-item-content">
                <div>{{record.belong==0?record.teacher_name+"老师":record.nickname}}</div>
                <div>{{record.content}}</div>
                <div class="file">
                  <div
                    class="item-image"
                    v-for="(item, index) in record.images"
                    :key="index"
                    @click="onClickFile(item.url)"
                  >
                    <img src="~@/assets/images/icon-image.png" alt />
                    <span>{{item.name}}</span>
                  </div>
                  <div
                    class="item-file"
                    v-for="(item, index) in record.files"
                    :key="index"
                    @click="onClickFile(item.url)"
                  >
                    <img src="~@/assets/images/icon-file.png" alt />
                    <span>{{item.name}}</span>
                  </div>
                </div>
                <!-- <div>
                  <img v-for="img in record.img_url" :src="img" :key="img" style="max-width:150px;" />
                </div>-->
              </div>
            </div>
            <a @click="deleteRecord(record.id,record.belong)">删除</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TeachOtoCommunication",
  data() {
    return {
      weeks: {
        1: "星期一",
        2: "星期二",
        3: "星期三",
        4: "星期四",
        5: "星期五",
        6: "星期六",
        0: "星期日"
      },
      teacher_id: "",
      user_id: "",
      oto_course_id: "",
      base_info: {},
      onlyTeacher: false,
      onlyStudent: false,
      list: []
    };
  },
  async created() {
    this.teacher_id = this.$route.query.teacher_id;
    this.user_id = this.$route.query.user_id;
    this.oto_course_id = this.$route.query.oto_course_id;

    await this.getData();
  },
  methods: {
    async getData() {
      let params = {
        teacher_id: this.teacher_id,
        user_id: this.user_id,
        oto_course_id: this.oto_course_id
      };
      if (this.onlyTeacher) {
        params.belong = 0;
      } else if (this.onlyStudent) {
        params.belong = 1;
      }
      let data = await this.$http.post("/api/oto/invite/record", params);
      this.base_info = data.base_info;

      let list = [];
      for (let key in data.communicate) {
        let item = { date: key, items: data.communicate[key] };
        let date = new Date(key);
        item.day = date.getDate();
        item.month = date.getMonth() + 1;
        item.year = date.getFullYear();
        item.week = this.weeks[date.getDay()];
        item.items.forEach(i => {
          // images
          i.images = [];
          i.img_url &&
            i.img_url.forEach(ci => {
              for (const key in ci) {
                i.images.push({
                  url: key,
                  name: ci[key]
                });
              }
            });
          // files
          i.files = [];
          i.file &&
            i.file.forEach(ci => {
              for (const key in ci) {
                i.files.push({
                  url: key,
                  name: ci[key]
                });
              }
            });
        });
        list.push(item);
      }
      this.list = list;
    },
    async onlyShowTeacher() {
      this.onlyStudent = false;
      await this.getData();
    },
    async onlyShowStudent() {
      this.onlyTeacher = false;
      await this.getData();
    },
    async deleteRecord(id) {
      await this.$promiseConfirm(
        "删除后学员和讲师都看不到该记录，确定删除么？"
      );
      await this.$http.delete("/api/oto/invite/record/" + id);
      this.$Message.deleteSuccess();
      await this.getData();
    },
    onClickFile(url) {
      window.open(url, "_blank");
    }
  }
};
</script>
<style lang="scss" scoped>
.baseinfo {
  font-size: 14px;
}

.baseinfo .info {
  color: #aaa;
  margin-left: 15px;
}

.baseinfo > div {
  margin-bottom: 24px;
}

.record-date {
  font-weight: bold;
  font-size: 14px;
  margin-right: 10px;
}

.record {
  display: flex;
}

.record-item {
  display: flex;
  .file {
    margin-top: 10px;
    .item-image,
    .item-file {
      margin-top: 5px;
      cursor: pointer;
      img {
        width: 15px;
        margin-right: 5px;
      }
      * {
        vertical-align: middle;
      }
    }
    .item-file {
      color: #4169ff;
    }
  }
}

.ivu-timeline-item:last-child .ivu-timeline-item-tail {
  display: block;
}

.ivu-timeline-item {
  padding-bottom: 30px !important;
  width: 400px;
}
</style>
